import React from 'react'
import "../Css/Header.css"
import PopupMenu from './PopupMenu'

function setLangUrl(lang){
    const urlParam = new URLSearchParams(window.location.search);
    urlParam.set("lang",lang)
    window.location.search =urlParam;
}

function Header() {
    return (
        <div className='header__root'>
            <a href='/'>
                <p>Lontoone</p>
            </a>
            <PopupMenu/>
            <div className='header__langBox-container'>
                <p onClick={()=>{setLangUrl("zh")}} >TW</p>
                <p onClick={()=>{setLangUrl("en")}}>EN</p>
            </div>
        </div>
    )
}

export default Header